export interface State {
  unreadCount: number;
  refreshQuery?: () => Promise<void>;
}

export type Action =
  | { type: 'SET_UNREAD_COUNT'; payload: number }
  | { type: 'INCREMENT_UNREAD_COUNT' }
  | { type: 'DECREMENT_UNREAD_COUNT' }
  | { type: 'SET_REFRESH_QUERY'; refreshQuery: () => Promise<void> };

export const defaultState = (): State => ({
  unreadCount: 0,
});

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SET_UNREAD_COUNT':
      return { ...state, unreadCount: action.payload };
    case 'INCREMENT_UNREAD_COUNT':
      return { ...state, unreadCount: state.unreadCount + 1 };
    case 'DECREMENT_UNREAD_COUNT':
      return { ...state, unreadCount: Math.max(0, state.unreadCount - 1) };
    case 'SET_REFRESH_QUERY':
      return { ...state, refreshQuery: action.refreshQuery };
    default:
      throw new Error('Unsupported action type');
  }
};
